import { INSURANCE_TYPES, TIME_OPTIONS, TIME_OPTIONS_FULL, TIME_OPTIONS_WORK } from "@global/const";

const M = {
    account: {
        id: '',
        description: '',
    },
    clinic: {
        id: '',
        displayed_network: '',
        name: '',
        city: '',
        area: '',
        locality: '',
        district: '',
        address: '',
        metros: [],
        reportOn: false,
        reportTo: '',
        reportCc: '',
        reportMessage: '',
        reportToName: '',

        img: '',
        imgOriginalPath: '',
        mapZoom: 16,
        markLat: 0,
        markLong: 0,
        types: [],
        url: '',
        website: '',
        socialVk: '',
        socialFb: '',
        socialInsta: '',
        socialOk: '',
        socialYoutube: '',
        socialTg: '',
        socialWhatsApp: '',

        workTime: {
            monFrom: '',
            monTill: '',
            tueFrom: '',
            tueTill: '',
            wedFrom: '',
            wedTill: '',
            thuFrom: '',
            thuTill: '',
            friFrom: '',
            friTill: '',
            satFrom: '',
            satTill: '',
            sunFrom: '',
            sunTill: '',
        },
        nameOfficial: '',
        licenceNum: '',

        client: false,
        email: '',
        searchMetros: [],
        searchMetrosManual: [],
        moderationNeeded: false,
        phone: '',
        registryPhone: '',
        proprietary: "",
        chiefDoctor: '',
        estYear: '',
        insuranceType: '',
        hasTerminal: 0,
        hasHospital: 0,
        hasLaboratory: 0,
        hasParking: 0,
        description: '',
        photos: [],
        licences: [],
        ratingInternal: '',
        ratingInternalDetailed: {
            hasBookingButton: 0,
            hasDescription: 0,
            hasShowInFeedClinicRatings: 0,
            hasShowInFeedDoctorRatings: 0,
            hasImg: 0,
            hasPhone: 0,
            hasWorktime: 0,
            hasPhotos: 0,
            hasLicences: 0,
            hasWebsite: 0,
            hasSocialVk: 0,
            hasSocialFb: 0,
            hasSocialInsta: 0,
            hasSocialOk: 0,
            hasSocialYoutube: 0,
            hasNameOficial: 0,
            hasChiefDoctor: 0,
            hasEstYear: 0,
            hasIsuranceType: 0,
            hasTerminal: 0,
            hasHospital: 0,
            hasLaboratory: 0,
            hasParking: 0,
        },
        price_type: 'DOCTU_SERVICES',
        is_medflex_on: 1,
        prices_statistic: {
            tree: {
                total: 0
            },
            pricelists: {},
        },
        price_files: [],
        uploadPhoneToYandexFeed: 1,
    },
    hasActiveSubscription: false,
    competitorUrls: [],
    subscriptions: [],
    children: [],
    parent: null,
    users: [],
}

export function GET_DEFAULT_M () { return JSON.parse(JSON.stringify(M));}
export function  initialState() { return JSON.parse(JSON.stringify(
    {
            M: M,
            networks: [],
            actionType: '',
            insuranceTypes: INSURANCE_TYPES,
            timeOptionsMon: TIME_OPTIONS,
            timeOptionsTue: TIME_OPTIONS,
            timeOptionsWed: TIME_OPTIONS,
            timeOptionsThu: TIME_OPTIONS,
            timeOptionsFri: TIME_OPTIONS,
            timeOptionsSat: TIME_OPTIONS,
            timeOptionsSun: TIME_OPTIONS,
            timeOptionsFull: TIME_OPTIONS_FULL,
            timeOptionsWork: TIME_OPTIONS_WORK,
            urlAvailable: true,
            yMap: null,
            yMapPlacemark: null,
            Mhashcode: null,
            foundParentClinics: [],
            foundChildrenClinics: [],
            buffClinicCity: '',
            buffClinicAddress: '',
            buffClinicLocality: '',
            linkedWithCrm: false,
            crmUrl: '',
            test: null,
            registryPhoneError: null,
            whatsAppPhoneError: null,
            doctuPhoneError: null,
            calltouchPhoneError: null,
            deletedSubscriptions: [],
    }
));}
